export const AppRoutes = {
  home: "/",
  products: "/products",
  productDetail: "/product",
  cart: "/cart",
  checkout: "/checkout",
  login: "/login",
  register: "/register",
  forgotPassword: "/forgotPassword",
  resetPassword: "/resetPassword",
  changePassword: "/changePassword",
  reviewList: "/reviews",
  editReview: "/editreview",
  profile: '/profile',
  orderSuccess: '/order-placed/:id',
  order: "/order",
  orderDetail: "/order/:id",
  favorite: '/favorite',
  promotion:'/promotion',
  aboutUs:'/aboutUs',
  contactUs:'/contactUs',
  errorPage:'/errorPage',
  privacy:'/privacy',
};
